/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { ExtendTrialButton } from '../ExtendTrialButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  appName?: string;
  canExtendTrial: boolean;
  onClose: () => void;
  onExtendTrialClick: () => void;
  onUpgradeClick: () => void;
};

export const PremiumAppLimitUpgradeNudge = ({
  appName,
  canExtendTrial,
  onClose,
  onExtendTrialClick,
  onUpgradeClick,
}: Props) => {
  const activeView = getActiveView({
    canExtendTrial,
  });

  const secondaryButton = canExtendTrial ? (
    <ExtendTrialButton key="extend-trial" onClick={onExtendTrialClick} />
  ) : (
    <CancelButton key="extend-trial" onClick={onClose} />
  );

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        <UpgradeButton key="upgrade" onClick={onUpgradeClick} />,
        secondaryButton,
      ]}
      headingText="You've run out of Premium Apps"
      id="premium-limit"
      image={
        <NudgeImage appName={appName} type={upgradeReasons.premiumLimit} />
      }
      subtitleText="Paid Feature"
    />
  );
};
